import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, message, Input, Form } from "antd";
import success from "../../../Assets/Icons/success.svg";
import { CopyOutlined } from "@ant-design/icons";
import "./style.css";

const APIKeyGenerated = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const location = useLocation();
  const productionKey = location.state?.apiKey;

  const handleDone = () => {
    navigate("/api-keys");
  };

  const handleCopyApiKey = () => {
    navigator.clipboard.writeText(productionKey);
    message.success("API key copied");
  };

  return (
    <div className="key-generated">
      <div className="key-card">
        <div className="email-logo">
          <img src={success} alt="logo" />
        </div>

        <div className="content-heading">API Key Generated Successfully</div>
        <div className="sub-heading">
          Your new developer API Key is ready for use in production
        </div>

        <div className="item">
          <Form name="api-key" layout="vertical" autoComplete="off">
            <Form.Item
              label="Production API Key"
              name="apiKey"
              initialValue={productionKey}
            >
              <Input
                readOnly
                suffix={
                  <CopyOutlined
                    style={{ cursor: "pointer" }}
                    onClick={handleCopyApiKey}
                  />
                }
              />
            </Form.Item>
          </Form>
        </div>
        <Button
          type="primary"
          htmlType="submit"
          className="submit-button"
          loading={loading}
          onClick={handleDone}
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default APIKeyGenerated;
